module.exports = __webpack_public_path__ + "img/02.a902ca2d.svg";